

























































































import VueOptions from '@utils/VueOptions'
import TitlePatternUtility from '@utils/TitlePatternUtility'
import EventHero from '@ui/Event/EventHero'
import AudienceListingBrandPartners from '@ui/AudienceListing/AudienceListingBrandPartners'
import EditorContent from '@components/EditorContent'
import CalendarService from '@services/CalendarService'

settings =
  name: 'AudienceAvailabilityDisplay'

  vue:
    props: ['audienceAvailability']

    components: {
      EventHero,
      AudienceListingBrandPartners,
      EditorContent,
    }

    computed:
      title: ->
        TitlePatternUtility.formatAvailabilityTitle @audienceAvailability

      statsCount: ->
        spaceKeys = Object.keys(@audienceAvailability.audience_listing?.spaces || {})
        catexKeys = Object.keys(@audienceAvailability.audience_listing?.catex || {})
        sampling: spaceKeys.filter((key) -> key.includes('product_sampling')).length,
        onsite: spaceKeys.filter((key) -> key.includes('booth')).length,
        exclusivity: catexKeys.length,
        alcohol: -1,
        packages: -1,
        more: -1,

      availabilityDate: ->
        return '' unless @audienceAvailability?.dates?[0]
        { starts_on: date, repeats, rrule_string: rruleString } = @audienceAvailability?.dates?[0]
        { seasons } = @audienceAvailability
        CalendarService.formatCalendarDate { date, repeats, rruleString, seasons }

export default VueOptions.vue settings
